import React, { useState } from 'react';
import AppPage from '../../../Core/AppPage';
import Application from '../../../Components/Application/Application';
import  './ApplicationsPage.scss'

export const Applications = ({ pageData, setActiveHeaderNav, accountData, setModalState }) => {

    return (
        <div id='application-page'>
            <Application
            	accountData= {accountData}
            	setModalState= {setModalState}
            />
        </div>
    );

}

const ApplicationsPage = AppPage(Applications);

export default ApplicationsPage;
